import { reportCoverShipment } from "../order/actions";
import {
  SHIPMENT_COVER_PAGE_REPORT_FAIL,
  SHIPMENT_COVER_PAGE_REPORT_REQUEST,
} from "../order/actionType";
import axios from "./utils/axios";

const fetchShipmentCoverReport = (searchDate) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SHIPMENT_COVER_PAGE_REPORT_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.get(
        `api/order/report_cover_page/${searchDate}/`,
        config
      );
      dispatch(reportCoverShipment(data));
    } catch (error) {
      dispatch({
        type: SHIPMENT_COVER_PAGE_REPORT_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchShipmentCoverReport;
